import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { INDUSTRIES } from "../data/content";

const Industries = () => {
  return (
    <section id="industries" className="relative bg-secondary/40 py-24 sm:py-32 lg:py-40" data-testid="industries-section">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-8 lg:px-12">
        <Reveal className="mb-16 max-w-3xl">
          <Eyebrow>04 — Industries</Eyebrow>
          <h2 className="mt-5 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Trusted across regulated, high-stakes sectors.
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {INDUSTRIES.map((ind, i) => {
            const Icon = Icons[ind.icon] || Icons.Building2;
            return (
              <Reveal key={ind.name} delay={i * 0.04}>
                <motion.div
                  whileHover={{ y: -5 }}
                  className="group flex h-full flex-col items-start gap-4 rounded-2xl border border-border bg-card p-6 transition-colors hover:border-teal"
                  data-testid={`industry-${ind.name.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-teal/10 text-teal transition-colors group-hover:bg-teal group-hover:text-white">
                    <Icon className="h-6 w-6" strokeWidth={1.75} />
                  </span>
                  <span className="font-display text-lg font-semibold text-foreground">{ind.name}</span>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
